var _defs, _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew232({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.84,10.14H5.11L3.9,7.56l-.35-.83v3.41H3V6h.72L4.9,8.44l.42,1V6h.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.51,6.48H8.28v3.66H7.71V6.48H6.49V6h3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.12,8a3.45,3.45,0,0,1,0,.57,2.15,2.15,0,0,1-.15.51,1.41,1.41,0,0,1-.26.42,1.44,1.44,0,0,1-.4.33,1.9,1.9,0,0,1-.54.21,3,3,0,0,1-.71.08h-.88V6h1.06a1.93,1.93,0,0,1,1.45.5A2.12,2.12,0,0,1,13.12,8Zm-.6,0a2.66,2.66,0,0,0-.08-.74,1.14,1.14,0,0,0-.25-.49.85.85,0,0,0-.42-.27,1.78,1.78,0,0,0-.59-.09h-.49V9.65h.42Q12.52,9.65,12.52,8.06Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.5,
    y: 3.7,
    width: 15,
    height: 8.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew232);
export default __webpack_public_path__ + "static/media/Symbolpack_New_232.23f65e0893e509265978e2ed56953b96.svg";
export { ForwardRef as ReactComponent };